import { useSyncExternalStore } from 'react';
import { hasAnalyticsConsent, applyCookieConsent } from '../services/analytics';
import { readCookieChoice } from '../services/cookieConsent';

export const hasSavedCookiePreferences = () => readCookieChoice() !== null;
export const notifyCookiePreferences = () => {
    applyCookieConsent();
    window.dispatchEvent(new Event('cookie-preferences-changed'));
};
const subscribe = (callback: () => void) => {
    window.addEventListener('cookie-preferences-changed', callback);
    window.addEventListener('storage', callback);
    return () => {
        window.removeEventListener('cookie-preferences-changed', callback);
        window.removeEventListener('storage', callback);
    };
};
export const useCookiePreferences = () => useSyncExternalStore(subscribe, hasAnalyticsConsent, () => false);
